<template>
    <div>
        <div v-if="!loaded" class="enqContent d-flex align-items-center">
            <strong>{{ __("Loading...") }}</strong>
            <div
                class="spinner-border ml-auto"
                role="status"
                aria-hidden="true"
            ></div>
        </div>

        <div v-else class="enqContent">
            <i v-if="disabled" class="fragment-disabled"></i>
            <div v-if="enquiry.quote_dates && enquiry.quote_dates.length > 0">
                <div class="form form-inline">
                    <div
                        class="form-group align-items-center w-100"
                        v-for="(qd, idx) in enquiry.quote_dates"
                        :key="qd.ID"
                    >
                        <label
                            :for="'qd' + qd.ID"
                            class="d-block d-xl-none col-xs-12 control-label text-left my-1"
                        >
                            <strong v-if="0 === idx">{{
                                __("Quote Issued")
                            }}</strong>
                        </label>
                        <label
                            :for="'qd' + qd.ID"
                            class="d-none d-xl-block col-xl-3 control-label text-right"
                        >
                            <strong v-if="0 === idx">{{
                                __("Quote Issued")
                            }}</strong>
                        </label>

                        <div class="col-xs-12 col-xl-9 w-100">
                            <a :id="'qd' + qd.ID" class="a-input">{{
                                formatDateTime(qd.dateTime)
                            }}</a>
                        </div>
                    </div>
                    <div class="mb-1"></div>
                </div>

                <hr v-if="enquiry.quote_dates.length > 1" />
            </div>

            <div class="form form-inline">
                <div
                    class="form-group align-items-center w-100 mb-1"
                    v-if="enquiry.quoteMarker"
                >
                    <label
                        for="quoteReadCount"
                        class="d-block d-xl-none col-xs-12 control-label text-left my-1"
                    >
                        <strong>{{ __("Quote Read Count") }}</strong>
                    </label>
                    <label
                        for="quoteReadCount"
                        class="d-none d-xl-block col-xl-3 control-label text-right"
                    >
                        <strong>{{ __("Quote Read Count") }}</strong>
                    </label>

                    <div class="col-xs-12 col-xl-9 w-100">
                        <a id="quoteReadCount" class="a-input">{{
                            enquiry.quoteReadCount
                        }}</a>
                    </div>
                </div>

                <div
                    class="form-group align-items-center w-100 mb-1"
                    v-if="enquiry.chaseCounter > 0"
                >
                    <label
                        for="chaseCounter"
                        class="d-block d-xl-none col-xs-12 control-label text-left my-1"
                    >
                        <strong>{{ __("Quote Chased Count") }}</strong>
                    </label>
                    <label
                        for="chaseCounter"
                        class="d-none d-xl-block col-xl-3 control-label text-right"
                    >
                        <strong>{{ __("Quote Chased Count") }}</strong>
                    </label>

                    <div class="col-xs-12 col-xl-9 w-100">
                        <a id="chaseCounter" class="a-input">{{
                            enquiry.chaseCounter
                        }}</a>
                    </div>
                </div>
            </div>

            <hr v-if="enquiry.quoteMarker || enquiry.chaseCounter > 0" />

            <form autocomplete="off" role="form" class="form form-inline">
                <div class="form-group align-items-center mb-1 w-100">
                    <label
                        for="templateID"
                        class="d-block d-xl-none col-xs-12 control-label text-left my-1"
                    >
                        <strong>{{ __("Document Templates") }}</strong>
                    </label>
                    <label
                        for="templateID"
                        class="d-none d-xl-block col-xl-3 control-label text-right"
                    >
                        <strong>{{ __("Document Templates") }}</strong>
                    </label>

                    <div class="col-xs-12 col-xl-9 w-100">
                        <select
                            v-model="templateID"
                            id="templateID"
                            class="form-control w-100 custom-select"
                            :disabled="disabled"
                        >
                            <option
                                v-for="code in languageCodes"
                                :key="code.ID"
                                :value="code.ID"
                                :disabled="
                                    code.ID !== 2 && APP_LOCALE === 'en_US'
                                "
                            >
                                {{ code.languageCode }}
                            </option>
                        </select>
                    </div>
                </div>

                <div class="form-group align-items-center mb-1 w-100">
                    <label
                        for="theirReferenceNumber"
                        class="d-block d-xl-none col-xs-12 control-label text-left my-1"
                    >
                        <strong>{{ __("Their Reference Number") }}</strong>
                    </label>
                    <label
                        for="theirReferenceNumber"
                        class="d-none d-xl-block col-xl-3 control-label text-right"
                    >
                        <strong>{{ __("Their Reference Number") }}</strong>
                    </label>

                    <div class="col-xs-12 col-xl-9 w-100">
                        <input
                            type="text"
                            autocomplete="off"
                            maxlength="50"
                            v-model="theirReferenceNumber"
                            class="form-control w-100"
                            id="theirReferenceNumber"
                            :disabled="disabled"
                            data-lpignore="true"
                        />
                    </div>
                </div>

                <div class="form-group align-items-center mb-3 w-100">
                    <label
                        for="quoteNotes"
                        class="d-block d-xl-none col-xs-12 control-label text-left my-1"
                    >
                        <strong>{{ __("Quotation Notes") }}</strong>
                    </label>
                    <label
                        for="quoteNotes"
                        class="d-none d-xl-block col-xl-3 control-label text-right"
                    >
                        <strong>{{ __("Quotation Notes") }}</strong>
                    </label>

                    <div class="col-xs-12 col-xl-9 w-100">
                        <textarea
                            v-model="quoteNotes"
                            class="form-control w-100"
                            id="quoteNotes"
                            rows="8"
                            :disabled="disabled"
                        ></textarea>
                    </div>
                </div>

                <div
                    class="offset-xs-0 offset-xl-3 col-xs-12 col-xl-9 d-flex align-items-center w-100"
                >
                    <div class="d-inline-block col-xl-8 px-0">
                        <button
                            type="submit"
                            class="btn btn-primary"
                            :disabled="updating || disabled"
                            @click.prevent="onUpdate"
                        >
                            Update
                        </button>

                        <button
                            type="submit"
                            class="btn btn-secondary"
                            :disabled="updating"
                            @click.prevent="onPreview"
                        >
                            {{ btnPreview }}
                        </button>

                        <button
                            type="submit"
                            class="btn btn-secondary"
                            :disabled="updating || quoteLock"
                            @click.prevent="onIssue"
                        >
                            {{ btnIssue }}
                        </button>
                    </div>

                    <div
                        class="d-flex align-items-center w-100"
                        v-if="updating"
                    >
                        <strong class="ml-4">{{ __("Updating...") }}</strong>
                        <div
                            class="spinner-border ml-auto"
                            role="status"
                            aria-hidden="true"
                        ></div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
const dateFns = require('date-fns');

const { format, parse } = dateFns;

export default {
    name: "EnqFragmentQuotation",

    props: {
        enquiry: {
            required: true,
            type: Object,
        },

        disabled: {
            required: true,
            type: Boolean,
        },

        updateEnquiry: {
            required: true,
            type: Function,
        },

        updateStatuses: {
            required: true,
            type: Function,
        },
    },

    data() {
        return {
            loaded: false,
            updating: false,

            templateID: this.enquiry.templateID,
            theirReferenceNumber: this.enquiry.theirReferenceNumber,
            quoteNotes: this.enquiry.quoteNotes,
        };
    },

    computed: {
        btnPreview() {
            if (this.enquiry.is_order) {
                return __("View Quotation");
            }

            return this.enquiry.quoteMarker
                ? __("View Quotation")
                : __("Preview Quotation");
        },

        btnIssue() {
            return this.enquiry.quoteMarker
                ? __("Re-Issue Quotation")
                : __("Issue Quotation");
        },

        quoteLock() {
            /**
             * If the quote is yet to be previewed, do not unlock the issue quote button.
             * Also, if the quote is not prepared, the user is not to issue a quote.
             * This is for if they update the quote notes since getting the enquiry overriden.
             * However, this rule goes out the window if the enquiry is 'Received' or 'Lost' where it is always locked.
             **/

            return !this.enquiry.previewMarker ||
                !this.enquiry.quotePreparedMarker ||
                this.enquiry.enquiryStatusID > 5
                ? true
                : false;
        },
    },

    methods: {
        formatDateTime(input) {
            const p =parse(input, "yyyy-MM-dd HH:mm:ss", new Date());

            return p.toLocaleDateString() + ' @ ' + format(p, 'HH:mm:ss');
        },

        onPreview() {
            this._onUpdate("preview", (data) => {
                window.open(data.enquiry.quote_preview_url);
            });
        },

        onIssue() {
            this._onUpdate("issue", (data) => {
                this.updateStatuses(data.statuses);
            });
        },

        onUpdate() {
            this._onUpdate();
        },

        _onUpdate(method = "update", callback) {
            this.updating = true;

            axios
                .post("/api/enquiries/fragment/quotation/" + method, {
                    enquiryID: this.enquiry.id,

                    templateID: this.templateID,
                    theirReferenceNumber: this.theirReferenceNumber,
                    quoteNotes: this.quoteNotes,
                })
                .then((response) => {
                    // console.log(response);
                    this.updating = false;

                    let data = response.data;
                    if (!data.success) {
                        if (data.errors) {
                            console.log(data.errors);
                        } else {
                            $("#fail-alert")
                                .text(data.message || "Unknown error")
                                .slideDown(500)
                                .delay(8000)
                                .slideUp(500);
                        }
                    } else {
                        this.updateEnquiry(data.enquiry);

                        if (callback) {
                            callback(data);
                        }
                    }
                })
                .catch((error) => {
                    console.error(error.response);
                    this.updating = false;

                    $("#fail-alert")
                        .text(error.toString() || "Unknown error")
                        .slideDown(500)
                        .delay(8000)
                        .slideUp(500);
                });
        },
    },

    watch: {},

    mounted() {
        axios
            .post("/api/enquiries/fragment/quotation/get", {
                enquiryID: this.enquiry.id,
            })
            .then((response) => {
                // console.log(response);

                let data = response.data;
                if (!data.success) {
                    $("#fail-alert")
                        .text(data.message || "Unknown error")
                        .slideDown(500)
                        .delay(5000)
                        .slideUp(500);
                } else {
                    this.loaded = true;
                    this.languageCodes = data.languageCodes;
                }
            })
            .catch((error) => {
                console.error(error.response);

                $("#fail-alert")
                    .text(error.toString() || "Unknown error")
                    .slideDown(500)
                    .delay(5000)
                    .slideUp(500);
            });
    },
};
</script>
